import { render, staticRenderFns } from "./ManageRoom.vue?vue&type=template&id=ec63bbd0&"
import script from "./ManageRoom.vue?vue&type=script&lang=ts&"
export * from "./ManageRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports